import { type FC } from 'react';

import Autocomplete, { type AutocompleteProps } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';

import { useViewportDimensions } from '@/src/components/hooks/useViewportDimensions';

import { type SearchedAssignedActivity } from './useSearchQueryData';

const TEXTFIELD_WIDTH_IN_PX = 360;

const StyledAutocomplete = styled(Autocomplete<SearchedAssignedActivity>)(({ theme }) => {
  const { isSmallViewport } = useViewportDimensions();

  return {
    ['& .MuiAutocomplete-inputRoot']: {
      backgroundColor: theme.palette.background.default,
    },
    width: isSmallViewport ? 'initial' : TEXTFIELD_WIDTH_IN_PX,
  };
});

export const SearchBarAutocomplete: FC<
  AutocompleteProps<SearchedAssignedActivity, false, false, false>
> = props => <StyledAutocomplete {...props} />;
